

































































































































































import { Component, Vue, Watch } from 'vue-property-decorator'
import controller from '@/app/ui/controllers/DropBoxController'
import { DropBox } from '@/domain/entities/DropBox'
import Button from '@/app/ui/components/Button/index.vue'
import Modal from '@/app/ui/components/Modal/index.vue'
import LoadingOverlay from '@/app/ui/components/LoadingOverlay/index.vue'
import Badge from '@/app/ui/components/Badge/index.vue'
import WarningIcon from '@/app/ui/assets/warning_icon_modal.vue'

@Component({
  components: {
    Button,
    Modal,
    LoadingOverlay,
    Badge,
    WarningIcon,
  },
})
export default class DropBoxDetailPage extends Vue {
  controller = controller
  deleteModal = false

  get externalId(): string {
    return this.$route.params.id
  }

  get dropBoxData(): DropBox | null {
    return this.controller.dropBoxDetail
  }

  get visibilityBadgeType(): string {
    const visibility = this.dropBoxData?.visibility?.toUpperCase()
    if (visibility === 'SHOWN') return 'success'
    if (visibility === 'HIDDEN') return 'error'
    return 'warning'
  }

  get googleMapsUrl(): string {
    if (!this.dropBoxData?.lat || !this.dropBoxData?.long) {
      return '#'
    }
    return `https://www.google.com/maps?q=${this.dropBoxData.lat},${this.dropBoxData.long}`
  }

  created(): void {
    if (this.externalId) {
      this.controller.getDropBoxDetail(this.externalId)
    } else {
      this.$router.push({ name: 'DropBoxListPage' })
    }
  }

  @Watch('controller.deleteSuccess')
  onDeleteSuccess(success: boolean): void {
    if (success) {
      this.controller.setDeleteSuccess(false)
      this.redirectToOrigin()
    }
  }

  private onBack(): void {
    this.redirectToOrigin()
  }

  private redirectToOrigin(): void {
    const origin = this.$route?.query?.origin
    if (origin === 'monitoring') {
      this.$router.push({ name: 'DropBoxMonitoringPage' })
    } else {
      this.$router.push({ name: 'DropBoxListPage' })
    }
  }

  private onEdit(): void {
    this.$router.push({
      name: 'EditDropBoxPage',
      params: { externalId: this.externalId },
      query: { origin: this.$route?.query?.origin },
    })
  }

  private onDelete(): void {
    this.deleteModal = true
  }

  private onConfirmDelete(): void {
    this.deleteModal = false
    const externalId = this.dropBoxData?.externalId
    if (externalId) {
      this.controller.deleteDropBox(externalId)
    }
  }
}
